function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 5.647C24.61 5.647 5.647 24.61 5.647 48 5.647 71.39 24.61 90.353 48 90.353c23.39 0 42.353-18.962 42.353-42.353 0-4.873-.822-9.548-2.332-13.897a2.824 2.824 0 015.335-1.853A47.935 47.935 0 0196 48c0 26.51-21.49 48-48 48S0 74.51 0 48 21.49 0 48 0a47.792 47.792 0 0124.002 6.423 2.824 2.824 0 11-2.828 4.888A42.145 42.145 0 0048 5.647z",
  fill: "#fff"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.447 66.222a2.714 2.714 0 115.428 0 2.714 2.714 0 01-5.428 0zM50.875 54.62a2.714 2.714 0 01-5.428 0v-22.8a2.714 2.714 0 015.428 0v22.8z",
  fill: "#fff"
});
function SvgErrorIconMb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default __webpack_public_path__ + "/img/ErrorIcon-mb.svg";
export { SvgErrorIconMb as ReactComponent };